import React from 'react';
import '../styles/App.css';
import NewsletterPortfolio from '../components/NewsletterPortfolio';

function App() {
  return (
    <div className="App">
      <NewsletterPortfolio />
    </div>
  );
}

export default App;
